__turbopack_context__.v({
  "badge": "ljrZxq_badge",
  "badgeImage": "ljrZxq_badgeImage",
  "body": "ljrZxq_body",
  "card": "ljrZxq_card",
  "cardInteractive": "ljrZxq_cardInteractive",
  "cardLayout": "ljrZxq_cardLayout",
  "iconBadge": "ljrZxq_iconBadge",
  "logoColorMark": "ljrZxq_logoColorMark",
  "navButton": "ljrZxq_navButton",
  "navSpacer": "ljrZxq_navSpacer",
  "npmBadge": "ljrZxq_npmBadge",
  "npmBadgeLabel": "ljrZxq_npmBadgeLabel",
  "npmBadgeVersion": "ljrZxq_npmBadgeVersion",
  "percentBadge": "ljrZxq_percentBadge",
  "placeholderBadge": "ljrZxq_placeholderBadge",
  "section": "ljrZxq_section",
  "track": "ljrZxq_track",
  "trackCentered": "ljrZxq_trackCentered",
  "vertaauxMark": "ljrZxq_vertaauxMark",
  "viewport": "ljrZxq_viewport",
  "viewportCentered": "ljrZxq_viewportCentered",
});
